import {
    FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST_SUCCESS,
    REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR,
    VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_SUCCESS,
    BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR,
    RESET_CHANGE_ACTIVITY_ASSIGNEE_STATE,
    CHANGE_ACTIVITY_REASSIGN_ERROR
} from '../../containers/SpockViewPage/actions/actionConstants';
import { GET_REASSIGN_ACTIVITY_REQUEST_SUCCESS } from '../ChangeAssignee/actionConstants';
import { IMAGE_BASE_PATH} from '../../containers/SpockViewPage/constants';


const initialState = {
    currentSponsor:{},
    sponsors:[],
    status:0,
    tzData:[],
    DueDateTz:''
};

export default function reducer(state=initialState, action){
    switch(action.type){
        case FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST_SUCCESS :
            return Object.assign(
                {},
                state,
                {
                    currentSponsor: mapCurrentAssigneeDataAsPerAssigneeType(action.payload.CurrentAssignee),
                    sponsors:mapSponsorsDataAsPerOrgAssigneeType(action.payload.Sponsors),
                    currentActDueDate:action.payload.CurrentActDueDate,
                    errorData: ""
                }
            );
        case VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_SUCCESS:
            return Object.assign(
                {}, state, action.payload
            )
        case REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR:
        case BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR:
            return Object.assign(
                {},
                state,
                {
                    errorData:action.payload.DefaultMessage
                }
            )
        case RESET_CHANGE_ACTIVITY_ASSIGNEE_STATE :
            return initialState;
        case CHANGE_ACTIVITY_REASSIGN_ERROR: {
            return Object.assign({}, state, action.payload)
        }
        case GET_REASSIGN_ACTIVITY_REQUEST_SUCCESS:{
            return Object.assign(
                {},
                state,
                {
                    currentSponsor: mapCurrentAssigneeDataAsPerAssigneeType(action.payload.reassignActivityModel),
                    sponsors: mapSponsorsDataAsPerOrgAssigneeType(action.payload.reassignActivityModel.TeamMembers),
                    currentActDueDate: action.payload.reassignActivityModel.PrettyDueDate,
                    errorData: "",
                    tzData:action.payload.tzData,
                    DueDateTz:action.payload.reassignActivityModel.DueDateTz
                }
            );
        }
        default :
            return state;
    }
}

function mapCurrentAssigneeDataAsPerAssigneeType(CurrentAssignee){
    if(!CurrentAssignee) {
        return {
            AssigneeType:"multi",
            FirstName:'Multiple Assignee',
            ProfileImage: IMAGE_BASE_PATH+'/images/multiple_user.png'
        }
    }

    return CurrentAssignee;
}

function mapSponsorsDataAsPerOrgAssigneeType(sponsors){
    const updatedSponsor = sponsors.slice();
    return updatedSponsor.map((item) => {
        item.ProfileImage = item.ProfileImage || item.OrganizationImage;
        item.FirstName = item.FirstName || item.OrganizationName;
        item.UserId = item.UserId || item.OrganizationId;
        return item;
    });
}